(function () {
  "use strict";

  // Fecha o popup da chamada
  const $btnCloseChamada = $(".home-chamada-close");
  const $chamadaPopup = $(".chamada-footer");
  $btnCloseChamada.on("click", closeChamada);
  function closeChamada() {
    $chamadaPopup.addClass("popup-hidden");
  }

  // Realiza o cadastro
  $("#eb-btn").on("click", function (ev) {
    ev.preventDefault();
    $("#form-ebook").submit();
  });
  var enviando_formulario = false;
  $("#form-ebook").on("submit", function (e) {
    e.preventDefault();

    var obj = this;
    var form = $(obj);
    var submit_btn = $("#eb-btn");
    var submit_btn_text = submit_btn.text();
    var dados = new FormData(obj);

    function volta_submit() {
      submit_btn.attr("disabled", false);
      submit_btn.text(submit_btn_text);
      enviando_formulario = false;
      hideLoading();
    }

    if (!enviando_formulario) {
      $.ajax({
        url: form.attr("action"),
        type: form.attr("method"),
        data: dados,
        processData: false,
        cache: false,
        contentType: false,
        beforeSend: function () {
          showLoading();
          enviando_formulario = true;
          submit_btn.attr("disabled", true);
          submit_btn.text("Aguarde...");
        },
        success: function (data) {
          console.log(data);
          //volta_submit();
          if (data == "ok") {
            if (form.hasClass("form-mineracao")) {
              //location.href = url_base + "ebook-mineracao/agradecimento";
              fbq("track", "Lead");
              setTimeout(() => {
                location.href =
                  "https://www.lpqv.com.br/loja-lucrativa/?ebook=true";
              }, 2000);
            } else {
              location.href = url_base + "ebook/agradecimento";
            }
            /* $("#form-ebook .campo").val("");
            showAlert(
              "Sucesso",
              "Parabéns! Seu cadastro foi realizado com sucesso. Em breve você receberá  o <b>Ebook Gratuito</b> no seu e-mail.",
              "success"
            ); */
          } else {
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar esta operação",
              "error"
            );
          }
        },
        error: function (xhr, type, exception) {
          volta_submit();
          showAlert("Erro", "Não foi possível realizar esta operação", "error");
          console.log("ajax error response type " + type);
        },
      });
    }
  });
})();
